var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayButtonHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#video-play-button-hover_svg__filter0_b_925_39822)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37,
    stroke: "#C1C2C3",
    strokeWidth: 6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 39.134a1 1 0 010 1.732L36 48.66a1 1 0 01-1.5-.866V32.206a1 1 0 011.5-.866l13.5 7.794z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "video-play-button-hover_svg__filter0_b_925_39822",
    x: -40,
    y: -40,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_925_39822"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_925_39822",
    result: "shape"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfYl85MjVfMzk4MjIpIj4KPGNpcmNsZSBjeD0iNDAiIGN5PSI0MCIgcj0iNDAiIGZpbGw9IndoaXRlIi8+CjxjaXJjbGUgY3g9IjQwIiBjeT0iNDAiIHI9IjM3IiBzdHJva2U9IiNDMUMyQzMiIHN0cm9rZS13aWR0aD0iNiIvPgo8L2c+CjxwYXRoIGQ9Ik00OS41IDM5LjEzNEM1MC4xNjY3IDM5LjUxODkgNTAuMTY2NyA0MC40ODExIDQ5LjUgNDAuODY2TDM2IDQ4LjY2MDNDMzUuMzMzMyA0OS4wNDUyIDM0LjUgNDguNTY0IDM0LjUgNDcuNzk0MkwzNC41IDMyLjIwNThDMzQuNSAzMS40MzYgMzUuMzMzMyAzMC45NTQ4IDM2IDMxLjMzOTdMNDkuNSAzOS4xMzRaIiBmaWxsPSJibGFjayIvPgo8ZGVmcz4KPGZpbHRlciBpZD0iZmlsdGVyMF9iXzkyNV8zOTgyMiIgeD0iLTQwIiB5PSItNDAiIHdpZHRoPSIxNjAiIGhlaWdodD0iMTYwIiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUdhdXNzaWFuQmx1ciBpbj0iQmFja2dyb3VuZEltYWdlRml4IiBzdGREZXZpYXRpb249IjIwIi8+CjxmZUNvbXBvc2l0ZSBpbjI9IlNvdXJjZUFscGhhIiBvcGVyYXRvcj0iaW4iIHJlc3VsdD0iZWZmZWN0MV9iYWNrZ3JvdW5kQmx1cl85MjVfMzk4MjIiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2JhY2tncm91bmRCbHVyXzkyNV8zOTgyMiIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgVideoPlayButtonHover as ReactComponent };